<template>

    <ThemeChanger>

        <PageHeader class="mt-32 lg:mt-48" :header="cms.not_found_h1"/>

        <AOS type="fade" easing="ease" duration="800" delay="1000">

            <Grid>

                <Column class="mt-8 mb-32 md:mt-11">

                    <HeaderAction :title="cms.header_action" :route-text="cms.header_button" :route="Route.Home"/>

                </Column>

            </Grid>

        </AOS>

    </ThemeChanger>

    <MetaInfo v-if="cms.seo" :seo="cms.seo"/>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import MetaInfo from '../components/MetaInfo.vue'
    import ThemeChanger from '../components/ThemeChanger.vue'
    import PageHeader from '../components/PageHeader.vue'
    import Column from '../components/Grid/Column.vue'
    import Grid from '../components/Grid/Grid.vue'
    import HeaderAction from '../components/HeaderAction.vue'
    import { useTheme } from '../compositions/UseTheme'
    import { Route } from '../enums/Route'
    import { Theme } from '../enums/Theme'
    import { useTranslation } from '../compositions/UseTranslation'

    export default defineComponent({
        name: 'NotFound',
        components: {
            PageHeader,
            ThemeChanger,
            MetaInfo,
            Column,
            Grid,
            HeaderAction
        },
        setup() {

            useTheme().initializeCurrentThemeBasedOnRouteMeta()

            const { notFound } = useTranslation()

            return {
                Route,
                Theme,
                cms: notFound
            }

        }
    })

</script>
